// Include styles
import '@resources/scss/styles.scss';

// 3rd party libraries
import Alpine from 'alpinejs';
window.Alpine = Alpine;
Alpine.start();

//includes
import '@templates/_includes/header';

// components
import '@templates/_components/example/example';
import '@templates/_components/banner/banner';
import '@templates/_components/ceremony-hero/ceremony-hero';
import '@templates/_components/ceremony-nav/ceremony-nav';
import '@templates/_components/description/description';
import '@templates/_components/gallery/gallery';
import '@templates/_components/gallery-stacked/gallery-stacked';
import '@templates/_components/homepage-hero/homepage-hero';
import '@templates/_components/inductees-timeline/inductees-timeline';
import '@templates/_components/logo-cloud/logo-cloud';
import '@templates/_components/member-cc/member-cc';
import '@templates/_components/member-header/member-header';
import '@templates/_components/member-password/member-password';
import '@templates/_components/member-plan/member-plan';
import '@templates/_components/member-profile/member-profile';
import '@templates/_components/member-sidebar/member-sidebar';
import '@templates/_components/news/news';
import '@templates/_components/news-top-banner/news-top-banner';
import '@templates/_components/news-single/news-single';
import '@templates/_components/past-ceremonies/past-ceremonies';
import '@templates/_components/people-grid/people-grid';
import '@templates/_components/people-text/people-text';
import '@templates/_components/profile-body/profile-body';
import '@templates/_components/profile-hero/profile-hero';
import '@templates/_components/related-news/related-news';
import '@templates/_components/rich-text/rich-text';
import '@templates/_components/scholarship-cards/scholarship-cards';
import '@templates/_components/special-awards/special-awards';
import '@templates/_components/top-banner/top-banner';
import '@templates/_components/video/video';